var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-menu",class:{ unactive: _vm.isActive }},_vm._l((_vm.elements),function(element){return _c('nav',{key:element.route},[_c('menu-element',{attrs:{"routingTo":element.route,"content":element.content,"logoName":element.logoName}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }